import "../pages.scss"
import { SlidersState } from '../../context/sliders/SlidersState';
import Datatable from "./slidersTable/Datatable"

const SlidersPage = () => {
  return (
    <>
      <SlidersState>
        <Datatable />
      </SlidersState>

    </>
  )
}

export default SlidersPage